(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["activa-campaign"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('activa-campaign')) customElements.define('activa-campaign',class extends HTMLElement {
    connectedCallback() {
      this.track=this.querySelector('.activa-campaign__track');
      this.track.querySelectorAll('[data-loop-copy]').forEach(photo=>photo.remove());
      this.photos=[...this.track.querySelectorAll('.activa-campaign__photo')];
      if(this.photos.length<2)return;
      this.photos.forEach(photo=>{const copy=photo.cloneNode(true);copy.setAttribute('data-loop-copy','');copy.setAttribute('aria-hidden','true');copy.removeAttribute('data-shopify-editor-block');this.track.append(copy);});
      this.abort=new AbortController();
      this.motion=matchMedia('(prefers-reduced-motion:reduce)');
      this.motion.addEventListener('change',()=>this.start(),{signal:this.abort.signal});
      this.resize=new ResizeObserver(()=>this.start());this.resize.observe(this);
      this.start();
    }
    start(){
      const progress=this.animation ? (Number(this.animation.currentTime)||0)/this.duration : 0;
      this.animation?.cancel();
      if(this.motion.matches)return;
      const distance=this.photos.reduce((sum,photo)=>sum+photo.getBoundingClientRect().width,0);
      this.duration=(Number(this.dataset.interval)||5000)*this.photos.length;
      this.animation=this.track.animate([{transform:'translateX(0)'},{transform:'translateX(-'+distance+'px)'}],{duration:this.duration,iterations:Infinity,easing:'linear'});
      this.animation.currentTime=(progress%1)*this.duration;
    }
    disconnectedCallback(){this.animation?.cancel();this.resize?.disconnect();this.abort?.abort();}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
